import { OwnerSearchEnum, PropertySearchEnum, ZoningSearchEnum, PropertyValuationSearchEnum } from "./property-search-model";
import { ArcGisOwnerColumn, ArcGisPropertyColumn, ArcGisZoningColumn, ArcGisSectionalTitleColumn } from "./arcgis-property-column.model";
import { ArcGisGraveColumn } from "../../../graves/shared/arcgis-grave-column";
import { GraveSearchEnum } from "../../../graves/shared/enums/graves/grave-search.enum";
export const PropertiesSearchColumnToArcGisColumnPropertyLookup = new Map([
    [PropertySearchEnum.ErfNumber, ArcGisPropertyColumn.ErfNumber],
    [PropertySearchEnum.FarmNumber, ArcGisPropertyColumn.FarmNumber],
    [PropertySearchEnum.Address, ArcGisPropertyColumn.Address],
    [PropertySearchEnum.SGNumber, ArcGisPropertyColumn.SGNumber],
    [PropertySearchEnum.Allotment, ArcGisPropertyColumn.Allotment],
    [PropertySearchEnum.PropertyDescription, ArcGisPropertyColumn.PropertyDescription],
    [PropertySearchEnum.PortionNumber, ArcGisPropertyColumn.PortionNumber],
    [PropertySearchEnum.AccountNumber, ArcGisPropertyColumn.AccountNumer],
    [PropertySearchEnum.PremiseId, ArcGisPropertyColumn.PremiseId],
]);
export const PropertiesSearchColumnToArcGisColumnSectionalTitleLookup = new Map([
    [PropertyValuationSearchEnum.ErfNumber, ArcGisSectionalTitleColumn.ErfNumber],
    [PropertyValuationSearchEnum.FarmNumber, ArcGisSectionalTitleColumn.FarmNumber],
    [PropertyValuationSearchEnum.Address, ArcGisSectionalTitleColumn.Address],
    [PropertyValuationSearchEnum.SGNumber, ArcGisSectionalTitleColumn.SGNumber],
    [PropertyValuationSearchEnum.Allotment, ArcGisSectionalTitleColumn.Allotment],
    [PropertyValuationSearchEnum.PropertyDescription, ArcGisSectionalTitleColumn.PropertyDescription],
    [PropertyValuationSearchEnum.PortionNumber, ArcGisSectionalTitleColumn.PortionNumber],
    [PropertyValuationSearchEnum.AccountNumber, ArcGisSectionalTitleColumn.AccountNumer],
    [PropertyValuationSearchEnum.PremiseId, ArcGisSectionalTitleColumn.PremiseId],
    [PropertyValuationSearchEnum.SectionalTitle, ArcGisSectionalTitleColumn.SectionalTitleId]
]);
export const PropertiesSearchColumnToArcGisColumnOwnerLookup = new Map([
    [OwnerSearchEnum.OwnerName, ArcGisOwnerColumn.OwnerName],
    [OwnerSearchEnum.OwnerSurname, ArcGisOwnerColumn.OwnerSurname],
    [OwnerSearchEnum.OwnerOrganisation, ArcGisOwnerColumn.OwnerOrganisation],
    [OwnerSearchEnum.OwnerRepresentative, ArcGisOwnerColumn.OwnerRepresentative],
    [OwnerSearchEnum.OwnerOrganisationRegNo, ArcGisOwnerColumn.OwnerOrganisationRegNo],
    [OwnerSearchEnum.OwnerIDNumber, ArcGisOwnerColumn.OwnerIDNumber],
    [OwnerSearchEnum.ErfNumber, ArcGisOwnerColumn.ErfNumber],
    [OwnerSearchEnum.Address, ArcGisOwnerColumn.Address],
    [OwnerSearchEnum.SGNumber, ArcGisOwnerColumn.SGNumber],
]);
export const PropertiesSearchColumnToArcGisColumnZoningLookup = new Map([
    [ZoningSearchEnum.Zoning, ArcGisZoningColumn.Zoning],
    [ZoningSearchEnum.ErfNumber, ArcGisZoningColumn.ErfNumber],
    [ZoningSearchEnum.Address, ArcGisZoningColumn.Address],
    [ZoningSearchEnum.SGNumber, ArcGisZoningColumn.SGNumber]
]);
export const LocationsSearchColumnToArcGisColumnGraveLookup = new Map([
    [GraveSearchEnum.Cemetery, ArcGisGraveColumn.Cemetery],
    [GraveSearchEnum.PlotNumber, ArcGisGraveColumn.PlotNumber],
    [GraveSearchEnum.GraveId, ArcGisGraveColumn.GraveID],
    [GraveSearchEnum.GraveStatus, ArcGisGraveColumn.GraveStatus],
    [GraveSearchEnum.Capacity, ArcGisGraveColumn.Capacity],
    [GraveSearchEnum.MarkerType, ArcGisGraveColumn.MarkerType]
]);
